import React, { useEffect, useState } from "react";
import TextEditor from "./TextEditor";
import "./editprofile.scss";
import { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import useFetchUserData from "hooks/useAuthUserData";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL } from "utils/ApiUrl";
import Loader from "utils/loader";

import { isValidPhoneNumber, parsePhoneNumber } from "libphonenumber-js";
import PhoneInput from "react-phone-input-2";

const Editprofile = () => {
  const [name, setName] = useState("Name");
  const [email, setEmail] = useState("Email");
  const [phoneNumber, setPhoneNumber] = useState("Phone Number");
  const [walletAddress, setWalletAddress] = useState("Wallet Address");
  const [walletFromResponse, setWalletFromResponse] = useState();
  const [imagePreview, setImagePreview] = useState(null); // For showing preview of the selected image
  const [imgFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  // const phonePattern = /^\d{11}$/; // Phone number validation (basic format: 11 digits)

  const fileInputRef = useRef(null);
  const accessToken = localStorage.getItem("accessToken");

  const [initialValues, setInitialValues] = useState({
    name: "Name",
    email: "Email",
    phoneNumber: "Phone Number",
    walletAddress: "Wallet Address",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_URL}/users/profile`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        const data = response?.data?.data;
        if (data) {
          setName(data?.name || "Name");
          setEmail(data?.email || "Email");
          setPhoneNumber(data?.phoneNumber || "Phone Number");
          setWalletAddress(data?.walletAddress || "Wallet Address");
          setWalletFromResponse(data?.walletAddress || null);

          // Store initial values
          setInitialValues({
            name: data?.name || "Name",
            email: data?.email || "Email",
            phoneNumber: data?.phoneNumber || "Phone Number",
            walletAddress: data?.walletAddress || "Wallet Address",
          });
        }
      } catch (error) {
        if (error?.response) {
          toast.error(error?.response?.data?.message);
        } else {
          console.log(error);
          toast.error("Error fetching profile data");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Handle the file upload
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log("Selected file:", file);
      setImageFile(file); // Update image file state
      // Create a preview of the selected image
      const imageUrl = URL.createObjectURL(file);
      setImagePreview(imageUrl);
    }
  };

  // Trigger the file input click event
  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Validate inputs before sending API requests
  const validateInputs = () => {
    if (!emailPattern.test(email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    // if (!phonePattern.test(phoneNumber)) {
    //   toast.error("Please enter a valid 11-digit phone number.");
    //   return false;
    // }

    return true;
  };

  // Update the profile image
  const handleImageChange = async () => {
    if (!imgFile) return;

    const formData = new FormData();
    formData.append("profileImage", imgFile);

    try {
      setLoading(true);
      const response = await axios.patch(
        `${API_URL}/users/profile-image`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      console.log("Image update response:", response);
      toast.success("Profile image updated successfully!");
      // window.location.reload();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Image update failed.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Function to dynamically create payload
  const generatePayload = () => {
    const updatedFields = {};
    if (name !== initialValues.name) updatedFields.name = name;
    if (email !== initialValues.email) updatedFields.email = email;
    if (phoneNumber !== initialValues.phoneNumber)
      updatedFields.phoneNumber = phoneNumber;
    if (walletAddress !== initialValues.walletAddress)
      updatedFields.walletAddress = walletAddress;

    return updatedFields;
  };

  // Update user fields (name, email, phone number, wallet address)
  const handleFieldChange = async () => {
    if (!validateInputs()) return;

    const payload = generatePayload();

    try {
      setLoading(true);
      const response = await axios.patch(`${API_URL}/users`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      toast.success("Profile updated successfully!");

      // Update fields in the UI with the API response
      const updatedData = response?.data?.data;
      if (updatedData) {
        setName(updatedData?.name || name);
        setEmail(updatedData?.email || email);
        setPhoneNumber(updatedData?.phoneNumber || phoneNumber);
        setWalletAddress(updatedData?.walletAddress || walletAddress);
        // window.location.reload();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Profile update failed.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const hasFieldChanges = () => {
    return (
      name !== initialValues.name ||
      email !== initialValues.email ||
      phoneNumber !== initialValues.phoneNumber ||
      walletAddress !== initialValues.walletAddress
    );
  };

  // Handle Save Changes click
  const handleSubmitChange = async () => {
    // Update image first
    if (hasFieldChanges() && imgFile) {
      await handleImageChange();
      await handleFieldChange();
    } else if (!hasFieldChanges() && imgFile) {
      await handleImageChange();
    } else if (hasFieldChanges() && !imgFile) {
      await handleFieldChange();
    } else if (!hasFieldChanges() && !imgFile) {
      toast.info("No changes detected.");
      return;
    }
  };

  const [inputs, setInputs] = useState({
    title: "",
    description: "",
    length: 0,
  });
  // console.log("inputsss", inputs);
  const setEditor = (data) => {
    console.log("we get here is ", data);
    setInputs({ ...inputs, description: data, length: data.length - 8 });
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow(false);
  const handleShow1 = () => setShow(true);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="content">
          <section className="addnewproduct">
            <div className="mainleftright">
              <div className="leftside">
                <div className="rightside">
                  <div className="innerrighrtside">
                    <div className="updodngouterdiv">
                      <div className="outtter_upload">
                        <h3>Profile Image</h3>
                        <div className="uplood__div">
                          <div className="dashedborderdiv">
                            <div
                              className="uploadbody"
                              style={{
                                position: "relative",
                              }}
                              onClick={handleUploadClick}
                            >
                              <input
                                type="file"
                                ref={fileInputRef}
                                style={{
                                  display: "none",
                                }}
                                onChange={handleFileUpload}
                              />
                              {imagePreview ? (
                                <>
                                  <img
                                    src={imagePreview}
                                    alt="Profile Preview"
                                  />
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setImagePreview(null);
                                    }}
                                    style={{
                                      position: "absolute",
                                      top: "5px",
                                      right: "5px",
                                      backgroundColor: "rgba(255, 0, 0, 0.8)",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "50%",
                                      width: "18px",
                                      height: "18px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      lineHeight: "1",
                                      zIndex: "10000",
                                    }}
                                  >
                                    &times; {/* HTML entity for a close icon */}
                                  </button>
                                </>
                              ) : (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="29"
                                  height="28"
                                  viewBox="0 0 29 28"
                                  fill="none"
                                >
                                  <path
                                    d="M11 11.6667C12.2887 11.6667 13.3333 10.622 13.3333 9.33333C13.3333 8.04467 12.2887 7 11 7C9.71133 7 8.66666 8.04467 8.66666 9.33333C8.66666 10.622 9.71133 11.6667 11 11.6667Z"
                                    stroke="black"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M15.6667 2.3335H11C5.16668 2.3335 2.83334 4.66683 2.83334 10.5002V17.5002C2.83334 23.3335 5.16668 25.6668 11 25.6668H18C23.8333 25.6668 26.1667 23.3335 26.1667 17.5002V11.6668"
                                    stroke="black"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M21.5 2.3335V9.3335L23.8333 7.00016"
                                    stroke="black"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M21.5 9.33333L19.1667 7"
                                    stroke="black"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M3.61499 22.1083L9.36666 18.2467C10.2883 17.6283 11.6183 17.6983 12.4467 18.41L12.8317 18.7483C13.7417 19.53 15.2117 19.53 16.1217 18.7483L20.975 14.5833C21.885 13.8017 23.355 13.8017 24.265 14.5833L26.1667 16.2167"
                                    stroke="black"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              )}
                              <div>
                                <h2>Click to upload</h2>
                                {/* <p>or drag and drop</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="productdiv">
                  <p className="pt-0">Name</p>
                  <input
                    type="text"
                    placeholder="Name"
                    className="appleinput"
                    value={name === "Name" ? null : name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <p>Email</p>
                  <input
                    type="text"
                    placeholder="Email"
                    className="appleinput"
                    value={email === "Email" ? null : email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <p>Phone Number</p>
                  <PhoneInput
                    country={"us"}
                    value={phoneNumber}
                    onChange={setPhoneNumber}
                    inputProps={{
                      id: "profile-phone-input",
                      placeholder: "Phone Number",
                      required: true,
                    }}
                    inputClass="custom-phone-input" // Keep styling consistent
                    buttonClass="custom-phone-button"
                    dropdownClass="custom-phone-dropdown"
                  />
                  <p>Wallet Address</p>
                  <input
                    type="text"
                    placeholder="Wallet Address"
                    className="appleinput"
                    value={
                      walletAddress === "Wallet Address" ? null : walletAddress
                    }
                    onChange={(e) => {
                      // if (
                      //   walletAddress !== "Wallet Address" &&
                      //   walletAddress !== null
                      // ) {
                      setWalletAddress(e.target.value);
                      // }
                    }}
                    readOnly={walletAddress === walletFromResponse}
                  />
                </div>
                <div className="mainbuttonpro ">
                  {/* <button className='classbut' >Coming Soon Project</button> */}
                  <button className=" privew" onClick={handleSubmitChange}>
                    {/* <button className=" privew" onClick={handleShow}> */}
                    Save Change’s
                  </button>
                </div>
              </div>
            </div>
          </section>
          <Modal
            className="ambmodalmain1"
            show={show}
            onHide={handleClose}
            centered
          >
            {/* <Modal.Header closeButton>
          <Modal.Title>
            Success
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header> */}
            <Modal.Body>
              <div className="modal2">
                {/* <img src='\product\tickkk.svg' className='tickkimg' alt='img' /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="213"
                  height="213"
                  viewBox="0 0 213 213"
                  fill="none"
                >
                  <path
                    d="M159.75 159.75C189.159 130.341 189.159 82.6591 159.75 53.2499C130.341 23.8407 82.6591 23.8407 53.2499 53.2499C23.8408 82.6591 23.8407 130.341 53.2499 159.75C82.6591 189.159 130.341 189.159 159.75 159.75Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M193.678 83.5901C189.64 68.1832 181.534 54.0668 170.235 42.7674C153.212 25.7444 130.578 16.3698 106.504 16.3698C82.4294 16.3698 59.7956 25.7444 42.7727 42.7674C31.4744 54.0656 23.3686 68.1814 19.3306 83.5883L16.2642 82.785C20.4442 66.8343 28.8362 52.2218 40.5318 40.5265C58.1529 22.9045 81.5829 13.1997 106.504 13.1997C131.425 13.1997 154.855 22.9045 172.476 40.5265C184.172 52.2221 192.564 66.836 196.744 82.7868L193.678 83.5901Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M200.903 81.5372C201.661 84.7393 199.678 87.9501 196.476 88.7071C193.273 89.4643 190.063 87.4814 189.306 84.2794C188.549 81.0773 190.531 77.8664 193.734 77.1095C196.936 76.3522 200.146 78.3348 200.903 81.5372Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M12.1043 81.5372C11.3471 84.7393 13.33 87.9501 16.532 88.7071C19.7344 89.4643 22.945 87.4814 23.7022 84.2794C24.4591 81.0773 22.4766 77.8664 19.2745 77.1095C16.0718 76.3522 12.8613 78.3348 12.1043 81.5372Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M106.504 199.797C81.5837 199.797 58.1536 190.092 40.5317 172.47C29.1014 161.04 20.8051 146.79 16.5388 131.258L19.595 130.418C23.7154 145.421 31.7311 159.187 42.7723 170.23C59.7961 187.252 82.4298 196.627 106.504 196.627C130.577 196.627 153.211 187.252 170.234 170.23C181.277 159.187 189.291 145.421 193.412 130.42L196.468 131.26C192.202 146.79 183.906 161.04 172.475 172.47C154.854 190.092 131.424 199.797 106.504 199.797Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M12.3886 132.553C11.5964 129.359 13.5441 126.127 16.7376 125.335C19.9312 124.543 23.1635 126.491 23.9556 129.685C24.7478 132.878 22.8004 136.11 19.6066 136.903C16.4124 137.694 13.1804 135.747 12.3886 132.553Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M200.619 132.553C201.411 129.359 199.464 126.127 196.27 125.335C193.076 124.543 189.844 126.491 189.052 129.685C188.26 132.878 190.207 136.11 193.401 136.903C196.595 137.694 199.827 135.747 200.619 132.553Z"
                    fill="#3FC700"
                  />
                  <path
                    d="M138.177 71.3188L92.7968 116.699L74.8306 98.7325L62.341 111.222L92.7968 141.678L150.667 83.8084L138.177 71.3188Z"
                    fill="white"
                  />
                </svg>
                <h4 className="changespass">Congratulations</h4>
                <p className="approveddiv">
                  Project has been successfully created.
                </p>
              </div>
              <div className="parentbuttons">
                <button
                  className="okay"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Done
                </button>
              </div>
            </Modal.Body>
          </Modal>

          {/* Error modal */}
          <Modal
            className="ambmodalmain1"
            show={show}
            onHide={handleClose1}
            centered
          >
            {/* <Modal.Header closeButton>
          <Modal.Title>
            Success
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header> */}
            <Modal.Body>
              <div className="modal2">
                {/* <img src='\product\tickkk.svg' className='tickkimg' alt='img' /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="213"
                  height="213"
                  viewBox="0 0 213 213"
                  fill="none"
                >
                  <path
                    d="M159.75 159.75C189.159 130.341 189.159 82.6591 159.75 53.2499C130.341 23.8407 82.6592 23.8407 53.25 53.2499C23.8408 82.6591 23.8407 130.341 53.2499 159.75C82.6591 189.159 130.341 189.159 159.75 159.75Z"
                    fill="#EB3B3B"
                  />
                  <path
                    d="M193.678 83.5903C189.64 68.1834 181.534 54.067 170.235 42.7676C153.212 25.7447 130.578 16.37 106.504 16.37C82.4294 16.37 59.7956 25.7447 42.7727 42.7676C31.4744 54.0658 23.3686 68.1817 19.3306 83.5886L16.2642 82.7853C20.4442 66.8345 28.8362 52.2221 40.5318 40.5267C58.1529 22.9048 81.5829 13.2 106.504 13.2C131.425 13.2 154.855 22.9048 172.476 40.5267C184.172 52.2224 192.564 66.8363 196.744 82.787L193.678 83.5903Z"
                    fill="#EB3B3B"
                  />
                  <path
                    d="M200.903 81.5374C201.661 84.7395 199.678 87.9504 196.476 88.7073C193.273 89.4645 190.063 87.4817 189.306 84.2796C188.549 81.0775 190.531 77.8666 193.734 77.1097C196.936 76.3525 200.147 78.3351 200.903 81.5374Z"
                    fill="#EB3B3B"
                  />
                  <path
                    d="M12.1044 81.5374C11.3471 84.7395 13.33 87.9504 16.5321 88.7073C19.7344 89.4645 22.945 87.4817 23.7023 84.2796C24.4592 81.0775 22.4766 77.8666 19.2745 77.1097C16.0719 76.3525 12.8613 78.3351 12.1044 81.5374Z"
                    fill="#EB3B3B"
                  />
                  <path
                    d="M106.504 199.797C81.5837 199.797 58.1537 190.093 40.5317 172.471C29.1014 161.04 20.8051 146.79 16.5388 131.258L19.595 130.419C23.7154 145.421 31.7311 159.187 42.7723 170.23C59.7961 187.253 82.4298 196.627 106.504 196.627C130.577 196.627 153.211 187.253 170.234 170.23C181.277 159.187 189.291 145.421 193.412 130.42L196.468 131.26C192.202 146.79 183.906 161.04 172.475 172.471C154.854 190.093 131.424 199.797 106.504 199.797Z"
                    fill="#EB3B3B"
                  />
                  <path
                    d="M12.3886 132.553C11.5964 129.359 13.5441 126.127 16.7376 125.335C19.9312 124.543 23.1635 126.491 23.9556 129.685C24.7478 132.878 22.8004 136.11 19.6066 136.903C16.4124 137.694 13.1804 135.747 12.3886 132.553Z"
                    fill="#EB3B3B"
                  />
                  <path
                    d="M200.619 132.553C201.411 129.359 199.464 126.127 196.27 125.335C193.076 124.543 189.844 126.491 189.052 129.685C188.26 132.878 190.207 136.11 193.401 136.903C196.595 137.694 199.827 135.747 200.619 132.553Z"
                    fill="#EB3B3B"
                  />
                  <path
                    d="M131 131.5L81.5005 82"
                    stroke="white"
                    stroke-width="17.5"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M130.5 82.5005L81 132"
                    stroke="white"
                    stroke-width="17.5"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                    stroke-linejoin="round"
                  />
                </svg>
                <h4 className="changespass">Error</h4>
                <p className="approveddiv">Project has been Errors created.</p>
              </div>
              <div className="parentbuttons">
                <button
                  className="okay"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Done
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
};

export default Editprofile;
